import { isPossiblePhoneNumber } from 'libphonenumber-js';

export const isPhoneNumberValid = (value: string) => isPossiblePhoneNumber(value, 'CA');

export const isEmailValid = (value: string | undefined | null) => value != null && /\b[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{2,}\b/.test(value);

export const isTenantIdentifierValid = (value: string) => /^[^-][a-zA-Z0-9-]*[^-]$/.test(value);

export const isValidDecimalNumber = (value?: string | null) => !!value && /^-?\d*(\d+\.\d+)?$/.test(value);